import React, { useRef } from 'react';
import { useSubscription } from '@autopylot-internal/state';
import { useInstance } from '../support/ioc/useInstance';
import { IonContent, IonModal } from '@ionic/react';
import { AircraftFormState } from './AircraftFormState.ts';
import { AircraftForm } from './AircraftForm.tsx';
import { Button } from '../components/button/Button.tsx';
import { PageHeader } from '../components/page/PageHeader.tsx';

export const AircraftFormModal: React.FC = () => {
    const state = useInstance(AircraftFormState);
    useSubscription(() => state);

    const formRef = useRef<HTMLFormElement>(null);

    const onSave = async () => {
        if (formRef.current?.reportValidity()) {
            await state.save();
        }
    };

    return (
        <IonModal isOpen={state.isOpen} onDidDismiss={state.cancel}>

            <PageHeader title={state.state.aircraftId ? 'Drone Details' : 'New Drone'} backLabel="Cancel" onBack={state.cancel} actionLabel="Save" onAction={onSave} />

            <IonContent className="ion-padding">

                <AircraftForm formRef={formRef} />

                {state.canDelete() && (
                    <div style={{margin: 20}}>
                        <Button color="danger" dataType="delete" fill='outline' onClick={state.delete}>Delete</Button>
                    </div>
                )}

            </IonContent>
        </IonModal>
    );
};
